import { render } from "./NavigationGroupItem.vue?vue&type=template&id=2d9b0708"
import script from "./NavigationGroupItem.vue?vue&type=script&lang=js"
export * from "./NavigationGroupItem.vue?vue&type=script&lang=js"
script.render = render

export default script